import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import MyImageComponent from './MyImageComponent'; // Import the updated MyImageComponent
import careerImg from '../assets/webp/career.webp'; // Replace with actual WebP image path
import logo from '../assets/webp/logo.webp'; // Replace with actual WebP image path
import './Courses.css'; 
import './CareerPage.css'; 

const CareerCard = ({ title, description, image }) => {
  return (
    <Card className="course-card">
      <div className="course-card-inner">
        <MyImageComponent src={logo} alt="ISIR.AI Logo" width="60" height="40" className="d-inline-block align-top" loading="eager" />
        <div className="course-card-front">
          <MyImageComponent src={image} alt={title} className="card-img-top" loading="eager" />
          <Card.Body>
            <Card.Title>{title}</Card.Title>
            <Card.Text className="coming-soon">We are hiring!</Card.Text>
            <Card.Text>{description}</Card.Text>
            <Card.Text>
              Share your CV with us at <a href="mailto:career@isir.ai">career@isir.ai</a> and tell us why you would like to join ISIR. Share your passion, key skills, and domain expertise with us.
            </Card.Text>
          </Card.Body>
        </div>
      </div>
    </Card>
  );
};

const truncateText = (text, maxLength) => {
  if (!text) return ''; // Return an empty string if text is undefined or null
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};


const JobOpeningCard = ({ job, onClick }) => {
  return (
    <Card className="course-card">
      <div className="course-card-inner">
        <Card.Body>
          <Card.Title>
            <Link to={`/jobs/${job._id}`} className="job-link">{job.title}</Link>
          </Card.Title>
          <Card.Text><strong>Experience:</strong> {job.experience}</Card.Text>
          <Card.Text><strong>Location:</strong> {job.location}</Card.Text>
          <Card.Text><strong>Type:</strong> {job.type}</Card.Text>
          <Card.Text><strong>Work Location:</strong> {job.workLocation}</Card.Text>
          <Card.Text><strong>Job Level:</strong> {job.experienceLevel}</Card.Text>
          <Card.Text><strong>Short Description:</strong> <div>{truncateText(job.shortDescription, 50)}</div></Card.Text>
          <Card.Text><strong>Status:</strong> {job.status}</Card.Text>
        </Card.Body>
      </div>
    </Card>
  );
};






const CareerPage = () => {
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get('http://localhost:5001/api/jobs');
        setJobs(response.data.filter(job => job.status === 'published'));
      } catch (error) {
        console.error('Error fetching jobs:', error);
      }
    };

    fetchJobs();
  }, []);

  const handleJobClick = (id) => {
    window.open(`/jobs/${id}`, '_blank'); // Open job details in a new tab
  };

  return (
    <Container className="courses-section my-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <h1 className="text-center">Career Opportunities</h1>
          <p className="text-center">We are looking for young and experienced talent in various domains. Join our team and make an impact!</p>
          <CareerCard
            title="Join Our Team"
            description="We are seeking both young and seasoned professionals across various domains, particularly in cutting-edge technologies like AI, Cloud, and Data Engineering. We are also looking for domain-specific experts with experience in industries such as Energy, Education, Ecommerce, Retail, Healthcare, Research, and Business Development. If you have a passion for AI and possess expertise in your field, we want to hear from you!"
            image={careerImg}
          />
        </Col>
      </Row>

      <hr className="my-5" />

      <Row className="justify-content-center mb-4">
        <Col md={8} className="text-center">
          <h2>Explore Our Current Openings</h2>
          <p>Discover exciting job opportunities and become part of our dynamic team. We value innovation, creativity, and a passion for technology. Explore our open positions and apply today to join us on our journey to shape the future.</p>
        </Col>
      </Row>

      <Row>
        {jobs.map((job) => (
          <Col key={job._id} md={4}>
            <JobOpeningCard job={job} onClick={() => handleJobClick(job._id)} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default CareerPage;
